<app-template-time [disabled]="disabled" [value]="value" [control]="control" [label]="label" />
